
export class DutiesDivPlanGoodsListModel {


  // 受注コード
  public OrderCode = String('');

  // 業態別企画商品一覧VOリスト
  public DutiesDivPlanGoodsVOList: Array<any> = [];

}
